import {
  draftDiscount,
  redoDiscountSchema,
} from "@redotech/redo-discounts-common/discount/discount-db-parser";
import * as z from "zod";

export const createDiscount = {
  name: "createDiscount" as const,
  input: z.object({ discountConfiguration: draftDiscount }),
  output: redoDiscountSchema,
};
